import { Controller } from "@hotwired/stimulus"

// One submit per click for a form Turbo does NOT handle (#14444).
//
// Turbo disables a form's submitter while a submission is in flight, so a
// double click on a Turbo form sends one request. A form marked `turbo: false`
// is submitted natively and gets no such guard: a double click on "Stop
// Impersonating" sent two DELETEs 26 ms apart; the second rode the session
// cookie the first had just destroyed, read as signed-out, and bounced the
// admin to the login page (production, 2026-09-26).
//
// The first submit passes and disables every submit control in the form (the
// event has already been dispatched, so disabling the button does not cancel
// it); any later submit while the page is still here is prevented.
//
//   = button_to path, method: :delete,
//       form: { data: { turbo: false, controller: 'single-submit', action: 'submit->single-submit#guard' } }
export default class extends Controller {
  #submitted = false

  guard (event) {
    if (this.#submitted) {
      event.preventDefault()
      return
    }
    this.#submitted = true
    this.element.querySelectorAll("button, input[type=submit]").forEach((control) => {
      control.setAttribute("aria-disabled", "true")
      control.disabled = true
    })
  }
}
